import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core'
import { UserContextService } from '@core/service/user-context.service'
import { SidenavService } from '../services/sidenav.service'
import { MenuItemConfig, MENU_ITEMS } from './header-menu-items'

const GOVBAR_OFFSET = 42
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  constructor(private sidenavService: SidenavService, private userContext: UserContextService) {}
  @Input()
  titulo: string

  @Input()
  toolbarClass: string

  @Output()
  scrollTop: EventEmitter<number> = new EventEmitter()

  private lastScrollTop = 0

  gap = GOVBAR_OFFSET

  menuItems: MenuItemConfig[]

  ngOnInit(): void {
    this.toolbarClass = 'mat-toolbar smart-scroll'
    this.menuItems = MENU_ITEMS.filter((item) => this.userContext.hasAnyRole(item.roles))
  }

  toggleSideNav(): void {
    this.sidenavService.toggle()
  }

  @HostListener('window:scroll', [])
  onScroll(): void {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    this.gap = scrollTop >= GOVBAR_OFFSET ? 0 : GOVBAR_OFFSET - scrollTop
    const scrollDirection = scrollTop < this.lastScrollTop ? 'up' : 'down'
    this.toolbarClass =
      scrollTop === 0 ? 'mat-toolbar smart-scroll' : `mat-toolbar smart-scroll scrolled-${scrollDirection}`
    this.lastScrollTop = scrollTop
    this.scrollTop.emit(scrollTop)
  }

  onLogout() {
    this.userContext.destroy()
  }
}
